import { forwardRef, useContext } from "react";

import { CheckboxPill, CheckboxPillProps } from "emoreg/molecules/checkbox";

import { GroupedCheckboxContext } from "../context";

export type CheckboxPillItemProps = Omit<
  CheckboxPillProps,
  "value" | "checked" | "id" | "hasError" | "error" | "aria-labelledby" | "onChange"
> & { value: string };

export const CheckboxPillItem = forwardRef<HTMLInputElement, CheckboxPillItemProps>(
  ({ value, ...props }, ref) => {
    const ctx = useContext(GroupedCheckboxContext);

    return (
      <CheckboxPill
        {...props}
        ref={ref}
        id={`${ctx.name}_${value}`}
        hasError={ctx.hasError}
        checked={ctx.values.includes(value)}
        aria-labelledby={ctx["aria-labelledby"]}
        onChange={ctx.onChange}
      />
    );
  }
);
